import { Card } from "primereact/card";
import { QuestionResponse } from "../models";
import { Button } from "primereact/button";
import { ApiEndpoints, Constants } from "../../../constants/appConstants";
import httpService from "../../../services/httpService";
import { Dialog } from "primereact/dialog";
import { useState } from "react";

export default function DocumentComponent({ response }: { response: QuestionResponse[] }) {
    // Function to handle file view/download
    const downloadDataFile = (fileName: string,filePath:string) => {
        httpService
            .post(
                `${ApiEndpoints.DownloadFileByRelativePath}`,{
                relativePath: filePath, fileName }
            ).then((response: any) => {
                    if (response) {
                        //console.log("response", response);
                        let url = response.data.url;
                        const validatedUrl = new URL(url);
                        if (
                            validatedUrl.protocol === "http:" ||
                            validatedUrl.protocol === "https:"
                        ) {
                            const anchor = document.createElement("a");
                            anchor.href = validatedUrl.toString();
                            anchor.target = "_blank";
                            anchor.click();
                        }
                    }
                },
                (error: any) => {
                    console.error("Error downloading file:", error);
                    setShowConfirmDialog(true);
                }
            );
    };

    const [showConfirmDialog, setShowConfirmDialog] = useState(false);

    const hideDialog = () => {
        setShowConfirmDialog(false);
    };

    return (
        <Card>
            {
                response.map((item: any) => {
                    // Safe JSON parser for the nested loop
                    const getFilesArray = (value: any) => {
                        try {
                            if (!value) return [];
                            const parsed = typeof value === 'string' ? JSON.parse(value) : value;
                            return Array.isArray(parsed) ? parsed : [];
                        } catch (e) {
                            console.error(`Failed to parse fieldValue for ${item.fieldName}`, e);
                            return [];
                        }
                    };

                    const filesList = getFilesArray(item.fieldValue);

                    return (
                        <div key={item.fieldName}>
                            <div className="file-upload-box" style={{ flexDirection: 'column', gap: '8px' }}>
                                {
                                    filesList.map((file: any) => (
                                        <a
                                            key={file.file_id}
                                            className="file-download-btn"
                                            style={{ marginBottom: 4 }}
                                            onClick={() => downloadDataFile(file.file_name,file.file_path)}
                                        >
                                            <i className="pi pi-download" style={{ marginRight: '8px' }} />
                                            {file.file_name}
                                        </a>
                                    ))
                                }
                            </div>
                        </div>
                    );
                })
            }

            <Dialog
                header="File not found!"
                visible={showConfirmDialog}
                onHide={hideDialog}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'end' }}>
                        <Button label="Close" icon="pi pi-times" className='p-button-secondary' onClick={hideDialog} autoFocus />
                    </div>
                }
            >
                <div>
                    <p>{Constants.FILE_NOT_FOUND_ERROR}</p>
                </div>
            </Dialog>
        </Card >
    )

} 